<template>
    <div>
        showing innovation submitted and it's form
    </div>
</template>